import { useCurrentUser } from 'Auth';

import { useIsAllowed } from '@gogame/permissions';

import { PERMISSION_ACTION_SMART_RULES_ADMIN } from 'scenes/SmartRules/constants';

export const useDisabledActions = ({ data }) => {
  const isAllowed = useIsAllowed();
  const currentUser = useCurrentUser();

  return (
    !isAllowed(PERMISSION_ACTION_SMART_RULES_ADMIN) &&
    currentUser.id !== data?.owner?.userId
  );
};
